import * as React from "react";
import { Box, MenuItem, Pagination, Select } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

interface EventEHRNewPaginationProps {
  totalCount: number;
  limit: number;
  currentPage: number;
  rowsPerPageOptions: any;
  totalPages: number;
  onPageChangeCb: (e: any) => void;
  handleChangeRowsPerPage?: (e: any) => void;
}

const theme = createTheme({
  components: {
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgb(0, 85, 150)", // Change selected color
            color: "white",
            "&:hover": {
              backgroundColor: "rgb(0, 100, 180)", // Change hover color
            },
          },
        },
      },
    },
  },
});

export default function EventEHRNewPagination({
  totalCount,
  limit = 10,
  currentPage,
  rowsPerPageOptions = [10, 25, 50],
  totalPages,
  onPageChangeCb,
  handleChangeRowsPerPage,
}: EventEHRNewPaginationProps) {
  // const [page, setPage] = React.useState(currentPage - 1);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(
    Number(limit || 10)
  );

  // React.useEffect(() => {
  //   setPage(currentPage - 1);
  // }, [currentPage]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    onPageChangeCb(newPage);
    // setPage(newPage);
  };

  const handleChangeRowsPerPages = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    handleChangeRowsPerPage &&
      handleChangeRowsPerPage(parseInt(event.target.value, 10));
    // setPage(1);
  };

  return (
    <div className="flex justify-between mt-4 items-center">
      {/* <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPages}
        rowsPerPageOptions={rowsPerPageOptions}
        
        sx={{
          ".MuiTablePagination-input	": {
            border: "1px solid rgb(0, 85, 150)",
            borderRadius: "4px",
          },
        }}
      /> */}

      <Box display="flex" alignItems="center">
        <span>Rows per page:</span>
        <Select
          value={rowsPerPage}
          onChange={(e: any) => {
            handleChangeRowsPerPages(e);
          }}
          size="small"
          sx={{
            marginLeft: 1,
            border: "1px solid rgb(0, 85, 150)",
            borderRadius: "4px",
            padding: "0px",
          }}
        >
          {rowsPerPageOptions.map((option: any) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <ThemeProvider theme={theme}>
        <Pagination
          page={currentPage}
          count={totalPages}
          showFirstButton={true}
          showLastButton={true}
          color="primary"
          onChange={(e: any, pageNumber: number) =>
            handleChangePage(e, pageNumber)
          }
        />
      </ThemeProvider>
    </div>
  );
}
